import React from 'react';
import CustomTable from '../../components/CustomTable';
import {globales, colores, funciones} from '../../global';
import AuthService            from '../../AuthService';
import Request from 'superagent';
import Paper from '@material-ui/core/Paper';
import {withStyles} from '@material-ui/core/styles';
import {Table, TableHeaderRow, TableSelection, TableFixedColumns} from '@devexpress/dx-react-grid-material-ui';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import Select from '../../components/Select';
import ListSubheader from '@material-ui/core/ListSubheader';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import BarraBotones   from '../../components/Barra_menu';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import Tooltip from '@material-ui/core/Tooltip';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import DialogContent from '@material-ui/core/DialogContent';
import LinearProgress from '@material-ui/core/LinearProgress';
import Backdrop from '@material-ui/core/Backdrop';
import {virtual} from '../../components/VirtualListBox';
import {IntegratedFiltering} from '@devexpress/dx-react-grid';
import Avatar from '@material-ui/core/Avatar';
import PersonIcon from '@material-ui/icons/Person';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Fade from '@material-ui/core/Fade';

let Auth = new AuthService();
let tokenInfo = [];

var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let planes = [];
const settingFilter = [
                      { columnName: 'HORA_ENTRADA',
                        predicate: (value, filter, row) => {
                        value = value !== null ? funciones.getTime(value) : value; 
                        return IntegratedFiltering.defaultPredicate(value, filter, row);
                        },
                      },
                      { columnName: 'HORA_SALIDA',
                        predicate: (value, filter, row) => {
                        value = value !== null ? funciones.getTime(value) : value; 
                        return IntegratedFiltering.defaultPredicate(value, filter, row);
                        },
                      },
                    ];

const styles = theme => ({

container: {
  display: 'flex',
  justifyContent: !movil ? 'center' : undefined, 
  alignItems: "center",
  flexDirection: !movil ? "row" : "column",
  paddingTop: "2px",
  paddingBottom: "5px", 
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1)
},
textField: {
  marginRight: !movil ? theme.spacing(1) : undefined,      
},
formControlSelect: {
  width: movil ? '100%' : '430px', 
  marginLeft: !movil ? theme.spacing(1) : undefined, 
  textAlign: 'left',
},
closeButton: {
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
},
paperConfirm: { 
  borderRadius: globales.border_dialog,
  minWidth: '320px', 
  maxWidth: '320px', 
},
paperCopy: { 
  borderRadius: globales.border_dialog,
  minWidth: !movil ? '500px' : undefined,
  maxWidth: !movil ? '500px' : undefined,
  height: !movil ? '620px' : undefined,
  maxHeight: !movil ? '95%' : undefined
},
formControlSelectCopy: {
  width: '100%', 
  marginTop: theme.spacing(0),    
  textAlign: 'left',
  marginBottom: theme.spacing(1.5)
},
backdrop: {
  zIndex: 500000,
  color: '#fff', 
  flexDirection: 'column'
},
divProgressCopy:{
  height: '48px',
  width: "100%",
  paddingTop: '20px', 
},
});
const widthTable = !movil ? window.screen.width - (globales.tabla.marginleft + globales.tabla.marginright) : 1336;
const columns = [
    { name: 'ICON', title: ' '  },
    { name: 'ID_ASISTENCIA_ALUMNO', title: 'ID_ASISTENCIA_ALUMNO'  },
    { name: 'DESCRIPCION_ACTIVIDAD', title: 'Descripción de actividad'  },
    { name: 'HORA_ENTRADA', title: 'Hora de entrada'  },
    { name: 'HORA_SALIDA', title: 'Hora de salida'  },
    { name: 'PUNTAJE', title: 'Puntos'  },
    { name: 'NOMBRE_AREA', title: 'Área'  },
];
const columnExtensions = [
  { columnName: 'ICON', width: 1 }, 
  { columnName: 'DESCRIPCION_ACTIVIDAD', width: widthTable * 0.50 }, 
  { columnName: 'HORA_ENTRADA', width: widthTable * 0.15, align: 'center' }, 
  { columnName: 'HORA_SALIDA', width: widthTable * 0.15, align: 'center' },
  { columnName: 'PUNTAJE', width: widthTable * 0.08, align: 'center' },
  { columnName: 'ID_ASISTENCIA_ALUMNO', width: 0}, 
  { columnName: 'NOMBRE_AREA', width: 0}, 
];
const grouping = [{ columnName: 'NOMBRE_AREA' }];

const totalSummaryItems = [
    { columnName: "DESCRIPCION_ACTIVIDAD", type: "count" },
    { columnName: "PUNTAJE", type: "sum" },    
];
const groupSummaryItems = [ 
  { columnName: "DESCRIPCION_ACTIVIDAD", type: "count" },
  { columnName: "PUNTAJE", type: "sum" },
];
const columnsCopy =  [  
  { name: 'ID_ASISTENCIA_ALUMNO', title: 'ID_ASISTENCIA_ALUMNO'  },
  { name: 'DESCRIPCION_ACTIVIDAD', title: 'Descripción de actividad'  },
  { name: 'PUNTAJE', title: 'Puntos'  },
  { name: 'NOMBRE_AREA', title: 'Área'  }
];
const columnExtensionsCopy = [
  { columnName: 'DESCRIPCION_ACTIVIDAD', width: 270 },
  { columnName: 'PUNTAJE', width: 65, align: 'center' },  
  { columnName: 'ID_ASISTENCIA_ALUMNO', width: 0},  
  { columnName: 'NOMBRE_AREA', width: 0}         
];

const RowId = row => row.ID_ASISTENCIA_ALUMNO;
const VirtualTable_cellComponent = (props) => {  

 if (props.column.name === 'HORA_ENTRADA')
 {
   return ( <Table.Cell {...props}>
             { props.row.HORA_ENTRADA !== null ? funciones.getTime(props.row.HORA_ENTRADA) : props.row.HORA_ENTRADA }
            </Table.Cell>);
 }
    
 if (props.column.name === 'HORA_SALIDA')
 {
   return ( <Table.Cell {...props}>
            { props.row.HORA_SALIDA !== null ? funciones.getTime(props.row.HORA_SALIDA) : props.row.HORA_SALIDA }
           </Table.Cell>);
 }

 return (<Table.Cell {...props}/>);
      
}
const stubCellComponentTable = (handleClickDelete, idRowSelection) => ({ colSpan,...props}) => {
  
  if (props.tableRow.type.toString() === 'Symbol(data)' && props.tableColumn.type.toString() === 'Symbol(group)')
  { 
     if (props.tableRow.row.ID_ASISTENCIA_ALUMNO === idRowSelection && tokenInfo.plataforma === 1)
     {  
       return (<Table.StubCell colSpan={props.tableColumn.key === "Symbol(flex)" ? 2 : colSpan} {...props}>
                  <Tooltip title="Eliminar">              
                         <IconButton onClick={handleClickDelete} style={{ marginLeft: 2 }} size="small">
                           <DeleteIcon />
                         </IconButton>  
                        </Tooltip> 
               </ Table.StubCell>);
     }
  }
  
  return (<Table.StubCell colSpan={props.tableColumn.key === "Symbol(flex)" ? 2 : colSpan} {...props} />); 

}
const ColumnFixed_cellComponent = ({showLeftDivider, showRightDivider, ...props}) => { 
  
  if (props.tableRow.key === "Symbol(filter)"){
    return (<TableFixedColumns.Cell {...props}>
             <div style={{ background: "white", height: "30px", width: "100%" }} />
             </TableFixedColumns.Cell>)
  }

  return (<TableFixedColumns.Cell 
              showLeftDivider={false}
              showRightDivider={false}
              style={{ backgroundColor: 'inherit' }}
              {...props} 
          />);
}
const ColumnHeader_cellComponent = (rowsLength, handleClick) => ({resizingEnabled, ...props}) => {
   
  resizingEnabled = props.column.name === 'ICON' ? false : resizingEnabled;

  if (props.column.name === 'ICON' && tokenInfo.plataforma === 1)
   {
       return (<TableHeaderRow.Cell style={{ paddingTop: 3, paddingBottom: 3 }} resizingEnabled={false} {...props}> 
                 <Tooltip title="Copiar actividades a otro plan">              
                   <IconButton onClick={handleClick} style ={{ left: '-50px', }} size="small">
                     <FileCopyIcon style={{ color: planes.length > 1 && rowsLength > 0 ? colores.tabla.color_iconos : colores.tabla.color_iconos_SL }} />
                   </IconButton>  
                  </Tooltip>  
               </TableHeaderRow.Cell>
              );
    }
    
   return (<TableHeaderRow.Cell resizingEnabled={resizingEnabled} {...props} />);
    
}
const RenderOption = (option) => (
  <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center" }}>
   <ListItemAvatar style={{ minWidth: 32 }}>
    <Avatar style={{ height: 23, width: 23 }}>
     <PersonIcon size="small"/>
    </Avatar>
   </ListItemAvatar>
  <div style={{ minWidth: "55px", color: "gray" }}>{option.CUENTA_ALUMNO}</ div>
  <div>{option.NOMBRE_COMPLETO}</div>
 </ div>
);

export default withStyles(styles) ( 
class App extends React.Component {

tablaRef = React.createRef();
planesRef = React.createRef();
tableCopyRef = React.createRef();
selectCopyRef = React.createRef();
dialogActionsRef = React.createRef();

  constructor (props) {
    super(props);
    this.state = {
       isLoggin: undefined,
       heightTableMain: 0,
       loadingMain: false,
       rows: [],
       valueAutoComplete: null,
       loadingClientes: true,
       openAutoComplete: false,
       optionAutocomplete: [],
       datosSelectPlan : null,
       selectedPlan: '',
       expandedGroups: [],
       idRowSelected: null,
       openModalConfirm: false,
       openModalCopy: false,
       rowsCopy: [],
       heightTableCopy: 0,
       expandedGroupsCopy: [],
       selectedCopy: '',
       datosSelectCopy: null,
       selection: [],
       copyLoading: false,
       openBackDrop: false,
       loadingPlanes: false,
   };
   this.cuenta= null;
   this.botones_eliminar =[
    {icono: 'Check', toolt: '', nombre: 'Aceptar', onclick: this.handleOkDelete, display:'auto'},
    {icono: 'Close', toolt: '', nombre: 'Cerrar' ,onclick: this.handleCloseConfirm, display:'auto', color: 'red'},
   ];
   this.botones_copy =[
    {icono: 'Check', toolt: '', nombre: 'Aceptar', onclick: this.handleOkCopy , display:'auto'},
    {icono: 'Close', toolt: '', nombre: 'Cerrar' ,onclick: this.handleCloseCopy, display:'auto', color: 'red'},
   ];
  
}

selectionPlanEstudio = (arrayPlanes) => {
   
    if (arrayPlanes.length === 0){
        
      return  '';
  
    } 
  
    if (arrayPlanes.length === 1){
        
      return  arrayPlanes[0].ID_PLAN;
  
    } 
    
    let select = arrayPlanes.filter(x => x.ESTADO.toString().trim().toUpperCase() ==='ACTIVO');
  
    if (select !== null && select.length > 0)
    {   
        return select[0].ID_PLAN;
    }
  
  
    select = arrayPlanes.filter(x => x.ESTADO.toString().trim().toUpperCase() ==='EGRESADO');
  
    if (select !== null && select.length > 0)
    {
        return select[0].ID_PLAN;
    }
  
  
    select = arrayPlanes.filter(x => x.ESTADO.toString().trim().toUpperCase() ==='GRADUADO');
  
    if (select !== null && select.length > 0)
    {
        return select[0].ID_PLAN;
    }
    
    return '';
     
  
}

handleChangeCuenta = (event) => {
    
this.cuenta = (event === null && tokenInfo.plataforma === 2) ? tokenInfo.user : tokenInfo.plataforma === 1 ? this.state.valueAutoComplete.CUENTA_ALUMNO : null;
this.setState({ loadingPlanes: true }, ()=>{ 
  
new Request
 .get(`${globales.ip}/actividades_coprogramaticas/planes/${this.cuenta}/${tokenInfo.plataforma}`)
 .set({'authorization': 'Bearer ' + Auth.getToken() })
 .retry(1)
 .timeout({ response: 15000, deadline: 30000, }) 
 .end((err, res) => {
                
   if (err) { 
         
   if (err.toString().substr(0,16) === 'Error: Forbidden')
   {
                      
     window.location.reload();
     return;
                        
   }
                
   planes = [];
   this.setState({ selectedPlan: '', datosSelectPlan: null, rows: [],  idRowSelected: null, loadingPlanes: false }, ()=>{  
     funciones.showToast('e', 'No hay conexión');
    });
                            
   return;
   }
                
   planes = JSON.parse(res.text);
   let niveles = [];
   let datosSelect = [];
          
   if (planes.length > 0) 
   {    
      planes.map((item, i) =>{
  
      if (!niveles.find(x => x === item.ID_NIVEL))
      {
        niveles.push(item.ID_NIVEL);  
        if (!datosSelect.find(x => x.label === item.DESCRIPCION_NIVEL.trim())){
             datosSelect.push({value: item.ID_NIVEL * -1, label: item.DESCRIPCION_NIVEL.trim() });
        }
  
        planes.map((itemx, j) =>{ 
         if (itemx.ID_NIVEL === item.ID_NIVEL)
          datosSelect.push({value: itemx.ID_PLAN, label: itemx.DESCRIPCION_PLAN });
         
         return item;
        });                             
                             
      }
                    
      return item;

     });
  
     let datosSelect_ = datosSelect.map((item, i) =>{
      if (item.value < 0)
       return (<ListSubheader value='' key={i} disableSticky>{item.label}</ListSubheader>);
      else
       return (<MenuItem value={item.value} key={i} >{item.label}</MenuItem>);
     });
                  
     this.setState({ datosSelectPlan: datosSelect_, selectedPlan: this.selectionPlanEstudio(planes), loadingPlanes: false });
     this.handleChangePlan('auto');
    }              
    else{ 
      planes = [];
      this.setState({ selectedPlan: '', datosSelectPlan: null, rows: [],  idRowSelected: null, loadingPlanes: false });    
    }
             
  });    
  
 });    

}

handleChangePlan = async (event) => {

  if (event !== 'auto' && this.state.selectedPlan === event.target.value)
  {
    return;
  }
  
  if (event === 'auto' || event.target.value > 0 )
  {  
    await Promise.resolve(this.setState({ selectedPlan: event === 'auto' ? this.state.selectedPlan : event.target.value, })); 
    this.obtenerActividadesCop(this.cuenta, event === 'auto' ? this.state.selectedPlan : event.target.value); 
  }

  
}

obtenerActividadesCop = (cuenta, id_plan)=>{

this.setState({ loadingMain: true }, ()=>{ 

  new Request
  .get(`${globales.ip}/actividades_coprogramaticas/alumno/historial/${cuenta}/${id_plan}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
          
     if (err) { 
  
      if (err.toString().substr(0,16) === 'Error: Forbidden')
      {    
        window.location.reload();
        return;       
      }
        
      this.setState({ rows: [], expandedGroups: [], expandedGroupsCopy: [], loadingMain: false }, ()=>{ 
       funciones.showToast('e', 'No hay conexión');
      });
            
      return;
     }
        
     const rows = JSON.parse(res.text);
  
     let allGroups = [];
     let found = null;

     rows.map((item, i) => {
      found = allGroups.find(area => area === item.NOMBRE_AREA);
      if (found == null)
       allGroups.push(item.NOMBRE_AREA);
      else 
       found = null;
               
      return null;
     });
             
     this.setState({ rows, expandedGroups: [], expandedGroupsCopy: allGroups, loadingMain: false });              
     
   });

 });

}

onChangeAutocomplete = (event, value) =>{
  
  planes = [];
  this.setState({ valueAutoComplete: value, openAutoComplete: false, selectedPlan: '', datosSelectPlan: null, rows: [], idRowSelected: null }, ()=>{
    
    if (value === null)
    {
      return;
    }

    this.handleChangeCuenta(null);   
    
  });
 

}

filtersClientes = (value)=>{ 
  
  new Request
   .get(`${globales.ip}/actividades_coprogramaticas/estudiantes/${value}`)
   .set({'authorization': 'Bearer ' + Auth.getToken() })
   .retry(0)
   .timeout({ response: 20000, deadline: 30000, }) 
   .end((err, res) => {
              
     if (err) { 
    
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
                  
         window.location.reload();
         return;
                    
       }
        
      this.setState({ optionAutocomplete: [], openAutoComplete: false, loadingClientes: false }, ()=>{
        funciones.showToast('e', 'No hay conexión');
      });
                
      return;
     }
            
     const rows = JSON.parse(res.text);
     this.setState({ optionAutocomplete: rows, loadingClientes: false }); 
                 
       
});
    
}

changeExpandedGroups = expandedGroups =>
{
  this.setState({ expandedGroups });  
}

onBlurAutoComplete = ()=>{

  if (this.state.openAutoComplete)
   this.setState({ openAutoComplete: false });    
      
}

handleOkDelete = ()=> {

 this.setState({ openModalConfirm: false, openBackDrop: true }, ()=>{  

  new Request
  .post(`${globales.ip}/actividades_coprogramaticas/alumno/operaciones`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .set('Content-Type', 'application/json')
  .send({ cuenta_alumno: '-', puntos: 0, id_actividad: 0, id_asistencia_alumno: this.state.idRowSelected, ad_usuario: tokenInfo.user })
  .retry(0)
  .timeout({ response: 15000, deadline: 60000, }) 
  .end((err, res) => {
          
     if (err) { 
  
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
              
          window.location.reload();
          return;
                
        }
  
       this.setState({ openBackDrop: false }, ()=>{ 
         funciones.showToast('e', 'No hay conexión'); 
        });
            
        return;
     }
        
     const rows = JSON.parse(res.text);
  
     if (rows.length > 0)
     {    
          if (rows[0].RESP === 'OK')
          {     
            this.setState({ rows: this.state.rows.filter(x => x.ID_ASISTENCIA_ALUMNO !== this.state.idRowSelected) }, ()=>{
              funciones.showToast('s', 'Actividad eliminada');
              this.setState({ idRowSelected: null, openBackDrop: false }); 
            })
                  
          }
          else
          {
             this.setState({ openBackDrop: false }, ()=>{ 
               funciones.showToast('w', rows[0].RESP); 
              }); 
              
          }
     }
                 
     
    });
  
  });

}

handleCloseConfirm = ()=>{
  this.setState({ openModalConfirm: false });
}

handleClickDelete = () => {
          
if (this.state.idRowSelected === null)
 return;

this.setState({ openModalConfirm: true });

}

onEnteringCopy = ()=>{

  this.setState({ heightTableCopy: funciones.getHeightTableDialog(movil, this.tableCopyRef, this.dialogActionsRef, !movil ? 7 : 5) }, ()=>{
    
    let indexSelected = this.state.datosSelectPlan.find(x => x.props.value === this.state.selectedPlan).key;
    let tmpValues = this.state.datosSelectPlan.filter(x => x.props.value !== this.state.selectedPlan);
    
    if (tmpValues[indexSelected - 1].props.value === '' && ((tmpValues[indexSelected] === undefined) || (tmpValues[indexSelected] !== undefined && tmpValues[indexSelected].props.value === '')))
    {          
       tmpValues = tmpValues.filter(x => parseInt(x.key) !== indexSelected - 1);       
    }

    this.setState({ datosSelectCopy: tmpValues });    

  });

}

handleCloseCopy = ()=>{
  
  if (this.state.copyLoading)
  {
      return;
  }

  this.setState({ openModalCopy: false }, 
                ()=>{
                  this.setState({ rowsCopy: [], selectedCopy: '', selection: [] })
                });

}

handleOkCopy = ()=>{

if (this.state.selection.length === 0)
{
  funciones.showToast('w', 'No hay actividades seleccionadas');
  return;
}

this.setState({ copyLoading: true }, ()=>{
  
  let strActividades = '';
  let idActividadTmp = null;

  this.state.selection.map((item, index )=>{
      
    idActividadTmp = this.state.rows.find(x => x.ID_ASISTENCIA_ALUMNO === item).ID_ACTIVIDADES_X_AREA;

    strActividades = (index + 1 < this.state.selection.length) ? strActividades + idActividadTmp + 'x' : strActividades + idActividadTmp;


    if (index + 1 === this.state.selection.length)
    {
        
      new Request
      .post(`${globales.ip}/actividades_coprogramaticas/alumno/copia_masiva`)
      .set({'authorization': 'Bearer ' + Auth.getToken() })
      .set('Content-Type', 'application/json')
      .send({ cuenta_alumno: this.cuenta, 
              id_plan_origen: this.state.selectedPlan, 
              id_plan_destino: this.state.selectedCopy, 
              str_actividades: strActividades, 
              ad_usuario: tokenInfo.user })
      .retry(0)
      .timeout({ response: 15000, deadline: 60000, }) 
      .end((err, res) => {
                 
          if (err) { 
          
            if (err.toString().substr(0,16) === 'Error: Forbidden')
            {
                      
              window.location.reload();
              return;
                        
            }
                        
            this.setState({ copyLoading: false }, ()=>{ 
              funciones.showToast('e', 'No hay conexión'); 
            });
                            
            return;
          }
                
        const rows = JSON.parse(res.text);
          
        if (rows.length > 0)
        {    
              if (rows[0].RESP === 'OK')
              {   
                    
                this.setState({ copyLoading: false }, ()=> {                 
                  funciones.showToast('s', 'Se copiaron todas las actividades seleccionadas');
                });     

              }
              else
              {
                
                this.setState({ copyLoading: false }, ()=> { 
                    funciones.showToast('w', rows[0].RESP);
                }); 

              }
        }
                        
            
      });

    }

    return item;

  });

  

});

}

changeExpandedGroupsCopy = expandedGroupsCopy =>
{
    this.setState({ expandedGroupsCopy });  
}

handleChangeCopy = event => { 

if (event.target.value > 0)
{

  this.setState({ selectedCopy: event.target.value }, ()=>{

      if (this.state.rowsCopy !== this.state.rows)
      {
          this.setState({ rowsCopy: this.state.rows });
      }

  });

}

}

changeSelection = selection =>{

  if (this.state.copyLoading)
  {
     return;
  }

  this.setState({ selection });

}

handleRowClick = (idRow) => event => {
 this.setState({ idRowSelected: idRow });  
}

handleClick = () => {
        
  if (planes.length > 1 && this.state.rows.length > 0 && !this.state.isLoading)
  { 
     this.setState({ openModalCopy: true });
  }

} 

onChangeInput = (e, value)=>{ 
    
  if (e === null || e.target.value === undefined)
  {
    if (this.state.openAutoComplete) 
      this.setState({ openAutoComplete: false });
               
    return;
  }
        
  if ((e.target.value.toString().trim().length < 3 || (this.state.valueAutoComplete !== null && value === this.state.valueAutoComplete.CUENTA_ALUMNO + ' | ' + this.state.valueAutoComplete.NOMBRE_COMPLETO)) && this.state.openAutoComplete)
    this.setState({ openAutoComplete: false });
  else if (e.target.value.toString().trim().length >= 3  && !this.state.openAutoComplete)
    this.setState({ openAutoComplete: true });
         
}

componentDidMount() { 

tokenInfo = Auth.getProfile(); //Token decodificado 
    
this.setState({ isLoggin: tokenInfo.plataforma !== undefined ? true : false }, ()=>{ 

  if (tokenInfo.plataforma === 1) // Usuario Admin
  {
    this.filtersClientes('-');
    
  }
  else if (tokenInfo.plataforma === 2) //Usuario estudiante
  {
    this.setState({ loadingClientes: false });
    this.handleChangeCuenta(null);     
  }
      
  this.setState({ heightTableMain: funciones.getHeightTableMain(movil, this).heightTable }, ()=>{
    if (!movil && tokenInfo.plataforma === 1)
    {
      document.getElementById('Est_Consulta').focus();
      return;
    }

    if (!movil)
    this.planesRef.current.focus();
  }); 
 
}); 
 
}

render() {
    
const { classes } = this.props;

  if (this.state.isLoggin === true)
  {
  return (
    
    <React.Fragment>
      <Paper className="Paper-main" square>
          {
            (() => {
              
            if (tokenInfo.plataforma === 1) //Si es Usuario Admin
             {
              
              return (
                <React.Fragment>
                 <div className={classes.container}>    
                   <Autocomplete
                      id="Est_Consulta"
                      options={this.state.optionAutocomplete}
                      getOptionLabel={(option) => option.CUENTA_ALUMNO + ' - ' + option.NOMBRE_COMPLETO}
                      style={{ width: movil ? '100%' : '430px' }}
                      renderInput={(params) => <TextField {...params} 
                                                  label="Estudiante"
                                                  variant="outlined"
                                                  onBlur={this.onBlurAutoComplete}                                                                                                                         
                                                  InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                               <React.Fragment>
                                                               {this.state.loadingClientes ? 
                                                               <Fade in style={{
                                                                    transitionDelay: '1000ms',
                                                                  }} unmountOnExit>
                                                               <CircularProgress size={18} /> 
                                                               </Fade>
                                                               : null}
                                                               {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                              ),
                                                    }}
                                                    fullWidth
                                                   />}
                      renderOption={RenderOption}                               
                      onChange={this.onChangeAutocomplete}
                      open={this.state.openAutoComplete}
                      loading={this.state.loadingClientes}
                      ListboxComponent={virtual.ListboxComponent}
                      value={this.state.valueAutoComplete} 
                      className={classes.textField}
                      disableClearable={this.state.isLoading}
                      onInputChange={this.onChangeInput}
                      popupIcon={null}
                      PaperComponent={(props)=>(<Paper elevation={8} {...props} />)}                                                                              
                      /> 
                      <Select Label='Plan de estudio'
                              Datos = {this.state.datosSelectPlan} 
                              Selected= {this.state.selectedPlan}
                              onChange={this.handleChangePlan}
                              Style={classes.formControlSelect}                                  
                              Outlined                                  
                              id='planes'                                  
                              Ref={this.planesRef}                            
                       />                               
                  
                   </div>
                   <Dialog open= {this.state.openBackDrop ? false : this.state.openModalConfirm}
                           classes = {{ paper: classes.paperConfirm }}>
                    <DialogTitle><Typography component='span' variant='subtitle2'>Actividad</Typography>
                      <IconButton className={classes.closeButton} onClick={this.handleCloseConfirm} size="small">
                        <CloseIcon fontSize="small"/>
                       </IconButton>
                    </DialogTitle>
                    <DialogContent style={{ paddingTop: "20px", textAlign: "center" }}>
                      <Typography variant="body1" gutterBottom>
                        ¿Está seguro de eliminar esta actividad?
                       </Typography>
                     </DialogContent>
                    <DialogActions style={{ marginTop: '20px'}}>
                      <BarraBotones botones={this.botones_eliminar} />
                    </DialogActions>
                  </Dialog>

                  <Dialog open= {this.state.openModalCopy}                            
                          TransitionProps={{ onEntering: this.onEnteringCopy }} 
                          classes = {{ paper: classes.paperCopy }}
                          fullScreen = {movil}
                          id='modalCopy'
                      >
                      <DialogTitle><Typography component='span' variant='subtitle2'>Copiar actividades</Typography>
                       <IconButton className={classes.closeButton} onClick={this.handleCloseCopy} size="small">
                        <CloseIcon fontSize="small"/>
                       </IconButton>
                      </DialogTitle>
                      <DialogContent style={{ paddingBottom: !movil ? '0px' : '5px' }} id='dialogContentCopy'>
                        <Select Label='Plan de estudio (destino)'
                                Datos={this.state.datosSelectCopy} 
                                Selected= {this.state.selectedCopy}
                                onChange={this.handleChangeCopy}
                                Style = {classes.formControlSelectCopy}                                 
                                Outlined                                  
                                id='Plan de Estudio Copy'                                  
                                Ref={this.selectCopyRef}                                   
                                 />
                        <div ref={this.tableCopyRef} className="disableTouchOptions">
                         <CustomTable 
                            Columns={columnsCopy} 
                            Rows={this.state.rowsCopy} 
                            Grouping={grouping} 
                            ExpandedGroups ={this.state.expandedGroupsCopy}
                            ChangeExpandedGroups={this.changeExpandedGroupsCopy}
                            getRowId={RowId}                                   
                            TableColumnExtensions={columnExtensionsCopy} 
                            columnWidths={columnExtensionsCopy}
                            DefaultHiddenColumnNames={['ID_ASISTENCIA_ALUMNO']}                                  
                            VirtualTable_cellComponent={VirtualTable_cellComponent}
                            height={this.state.heightTableCopy} 
                            enabledFilterRows
                            showSelectionColumn                                      
                            Selection ={this.state.selection}
                            ChangeSelection={this.changeSelection}
                            showSelectAll                                      
                            leftColumnsFixed={[TableSelection.COLUMN_TYPE]}
                            columnFixedCellComponent={ColumnFixed_cellComponent} 
                            />
                          </ div>
                        </DialogContent>
                       <DialogActions ref={this.dialogActionsRef} style={{ maxHeight: "69px", minHeight: "69px" }}>
                        {(() => {

                          if (this.state.copyLoading)                          
                            return(<div className={classes.divProgressCopy}>     
                                      <LinearProgress />
                                   </div>);
            
                          return(<BarraBotones botones={this.botones_copy} />);
              
                        })()}
                      </DialogActions>
                  </Dialog>

                </React.Fragment>
              );

             }             
             else if (tokenInfo.plataforma === 2) //Si es estudiante
             {
                return(
                  <React.Fragment>
                    <div className={classes.container}>
                     <Select Label='Plan de estudio'
                             Datos = {this.state.datosSelectPlan} 
                             Selected= {this.state.selectedPlan}
                             onChange={this.handleChangePlan}
                             Style = {classes.formControlSelect}                               
                             Outlined                                  
                             id='planes'                                  
                             Ref={this.planesRef}/>   
                    </div>
                  </React.Fragment>
                );
             }

            })()

          }
          <div ref={this.tablaRef} className="disableTouchOptions" style={{ marginLeft: !movil ? globales.tabla.marginleft : globales.tabla.marginleft_movil, marginRight: !movil ? globales.tabla.marginright : globales.tabla.marginright_movil  }} id='dcg'>
           <CustomTable 
             Columns={columns} 
             Rows={this.state.rows}
             Grouping={grouping} 
             TableColumnExtensions={columnExtensions} 
             columnWidths={columnExtensions} 
             DefaultHiddenColumnNames={['ID_ASISTENCIA_ALUMNO']}  
             ExpandedGroups={this.state.expandedGroups}
             ChangeExpandedGroups={this.changeExpandedGroups}
             VirtualTable_cellComponent={VirtualTable_cellComponent}
             height = {this.state.heightTableMain} 
             loading={this.state.loadingMain}
             getRowId={RowId}
             rowSelected={this.state.idRowSelected}
             rowClick={this.handleRowClick}
             enabledFilterRows 
             rowHeaderCellComponent={ColumnHeader_cellComponent(this.state.rows.length, this.handleClick)}
             FilteringColumnExtensions = {settingFilter}
             totalItems={totalSummaryItems}
             groupItems={groupSummaryItems}
             summaryRowMessages={{ count: 'Actividades', sum: 'Puntos' }}
             stubCellComponentTable={stubCellComponentTable(this.handleClickDelete, this.state.idRowSelected)}               
             />     
             </div>

             <Backdrop className={classes.backdrop} open={this.state.openBackDrop}>                                       
                <CircularProgress color="inherit" />
                <span style={{ marginTop: '10px' }}>Eliminando...</span>
            </Backdrop>
            <Backdrop open={this.state.loadingPlanes || this.state.loadingMain || this.state.copyLoading || this.state.loadingClientes} 
                      className={classes.backdrop} 
                      invisible 
                      transitionDuration={0}/>

        </Paper>
      </React.Fragment>
  );
  }
else if (this.state.isLoggin === false)
{
  //Auth.logout();
  window.location.reload();
  return; //((<Redirect to="/login"/>))
}
return null;

}//FIN RENDER
}

)
